import React from 'react';
import classNames from 'classnames';
import PrenavMenu from '../ui/prenav-menu/PrenavMenu';
import styles from './prenav-link.scss';
import dispatchMonetateQEvent from '../../utils/monetate/monetateEventDispatcher';
import { notifyNavAnalytics } from '../navigation/notify-analytics';

const PrenavLink = props => {
  const clickHandler = e => {
    dispatchMonetateQEvent(
      `prenav-menu-click.${e.target.innerHTML.replace(/ /g, '-').toLowerCase()}`
    );
    notifyNavAnalytics('pn', e.target.innerHTML);
  };

  return (
    <div
      className={styles.headerLinksContainer}
      data-testid="prenav-redesign-container"
    >
      <a
        className={classNames(styles.headerLinkItem, {
          [styles.underlinedHeaderLinkItem]: props.menuLinks.length === 0,
          [styles.headerLinkItem__prenav]: props.isNewPreNavActive,
          [styles.underlinedHeaderLinkItem__prenav]:
            props.menuLinks.length === 0,
        })}
        href={props.url || '#'}
        onClick={
          props.menuLinks.length > 0 ? e => e.preventDefault() : clickHandler
        }
      >
        {props.children}
      </a>
      {props.isNewPreNavActive && props.menuLinks.length > 0 && (
        <PrenavMenu {...props} itemClassName={styles.prenavLinkMenuBox} />
      )}
    </div>
  );
};

export default PrenavLink;
